import { animated } from '@react-spring/web';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { CheckboxProps } from '../Checkbox';

interface CheckmarkBackgroundProps extends Pick<CheckboxProps, 'disabled' | 'checked'> {
    $indeterminate?: boolean;
}

export const CheckmarkBackground = styled(animated.div)<CheckmarkBackgroundProps>`
    position: relative;
    width: 18px;
    height: 18px;
    background-color: ${(props) => {
        if (props.disabled) {
            return theme.colors.background.disabled;
        }

        return props.checked || props.$indeterminate ? theme.colors.accent.emphasis : theme.colors.background.muted;
    }};
    border-radius: ${theme.radii[4]};
    transition: background-color 100ms ease-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;
